// //  NOTE :::: permissions starting from is... (for ex : isQuotation) are  meant for access to users who have that module in their plan. If its false then it sees an upgrade plan modal

export const Permission = (permission, type_user) => {
    const user_type = Number(type_user)

    const isAdmin = user_type === 1;

    const normalize = (value = '') =>
        value?.toLowerCase()?.split(' ')?.join('_');

    const permissionMap = {};

    permission?.forEach(item => {
        const moduleName = normalize(item?.module_name);
        const featureName = normalize(item?.feature_name);

        if (!permissionMap[moduleName]) {
            permissionMap[moduleName] = {};
        }

        permissionMap[moduleName][featureName] = item;
    });

    const crud = (moduleName, featureName) => ({
        isView: isAdmin ? true : Boolean(Number(permissionMap?.[moduleName]?.[featureName]?.view)),
        isCreate: isAdmin ? true : Boolean(Number(permissionMap?.[moduleName]?.[featureName]?.create)),
        isEdit: isAdmin ? true : Boolean(Number(permissionMap?.[moduleName]?.[featureName]?.edit)),
        isDelete: isAdmin ? true : Boolean(Number(permissionMap?.[moduleName]?.[featureName]?.delete)),
    });

    const action = (moduleName, featureName) =>
        isAdmin ? true : Boolean(Number(permissionMap?.[moduleName]?.[featureName]?.is_action));

    const isQuotation = Boolean(permissionMap?.quotation);
    const isPurchase = Boolean(permissionMap?.purchase_order);
    const isSalesOrder = Boolean(permissionMap?.sales_order);
    const isInvoice = Boolean(permissionMap?.invoice);
    const isRecurring = Boolean(permissionMap?.recurring_invoice);
    const isProject = Boolean(permissionMap?.project);
    const isCalendar = Boolean(permissionMap?.calendar);
    const isReport = Boolean(permissionMap?.reports);
    const isPayment = Boolean(permissionMap?.payment);
    const isWorkFlow = Boolean(permissionMap?.workflow);
    const isCampaigning = Boolean(permissionMap?.campaigning);

    return {
        dashboard: {
            taskboard: isAdmin ? true : Boolean(Number(permissionMap?.dashboard?.taskboard?.view)),
            sales_dashboard: isAdmin ? true : Boolean(Number(permissionMap?.dashboard?.sales_dashboard?.view)),
            financial_dashboard: isAdmin ? true : Boolean(Number(permissionMap?.dashboard?.financial_dashboard?.view)),
            inboxView: isAdmin ? true : Boolean(Number(permissionMap?.dashboard?.inbox?.view)),
            projectView: isAdmin ? true : Boolean(Number(permissionMap?.dashboard?.project?.view))
        },
        leads: {
            ...crud('leads', 'leads'),
            isImport: action('leads', 'import'),
            isExport: action('leads', 'export'),
            feature: {
                followup: { ...crud('leads', 'followup') },
                notes: { ...crud('leads', 'notes') },
                meeting: { ...crud('leads', 'meeting') },
                document: { ...crud('leads', 'document') },
                pipeline: { ...crud('leads', 'pipeline') }
            }
        },
        deals: {
            ...crud('deals', 'deals'),
            isImport: action('deals', 'import'),
            isExport: action('deals', 'export'),
            feature: {
                followup: { ...crud('deals', 'followup') },
                notes: { ...crud('deals', 'notes') },
                meeting: { ...crud('deals', 'meeting') },
                document: { ...crud('deals', 'document') },
                pipeline: { ...crud('deals', 'pipeline') }
            },
        },
        contact: {
            ...crud('contact', 'contact'),
            isImport: action('contact', 'import'),
            isExport: action('contact', 'export'),
            feature: {
                task: { ...crud('contact', 'task') },
                notes: { ...crud('contact', 'notes') },
                meeting: { ...crud('contact', 'meeting') },
                document: { ...crud('contact', 'document') },
            }
        },
        company: {
            ...crud('company', 'company'),
            isImport: action('company', 'import'),
            isExport: action('company', 'export'),
            feature: {
                notes: { ...crud('company', 'notes') },
                activity: { ...crud('company', 'activity') },
                document: { ...crud('company', 'document') },
            }
        },
        quotation: {
            isAuthorized: isQuotation,
            ...crud('quotation', 'quotation'),
            isRevised: action('quotation', 'revised'),
            isImport: action('quotation', 'import'),
            isExport: action('quotation', 'export'),
        },
        purchase_order: {
            isAuthorized: isPurchase,
            ...crud('purchase_order', 'purchase_order'),
            isImport: action('purchase_order', 'import'),
            isExport: action('purchase_order', 'export'),
        },
        sales_order: {
            isAuthorized: isSalesOrder,
            ...crud('sales_order', 'sales_order'),
            isImport: action('sales_order', 'import'),
            isExport: action('sales_order', 'export'),
        },
        invoice: {
            isAuthorized: isInvoice,
            ...crud('invoice', 'invoice'),
            isImport: action('invoice', 'import'),
            isExport: action('invoice', 'export'),
        },
        recurring_invoice: {
            isAuthorized: isRecurring,
            ...crud('recurring_invoice', 'recurring_invoice'),
        },
        project: {
            isAuthorized: isProject,
            ...crud('project', 'project'),
            isImport: action('project', 'import'),
            isExport: action('project', 'export'),
            feature: {
                task: { ...crud('project', 'task') },
                notes: { ...crud('project', 'notes') },
                meeting: { ...crud('project', 'meeting') },
                document: { ...crud('project', 'document') },
            }
        },
        calendar: {
            isAuthorized: isCalendar,
            ...crud('calendar', 'calendar'),
        },
        reports: {
            isAuthorized: isReport,
            contact: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.contact?.view)),
            },
            company: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.company?.view)),
            },
            leads: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.leads?.view)),
            },
            deals: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.deals?.view)),
            },
            quotation: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.quotation?.view)),
            },
            sales_order: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.sales_order?.view)),
            },
            purchase_order: {
                isView: isAdmin ? true : Boolean(Number(permissionMap?.reports?.purchase_order?.view)),
            },

        },
        payment: {
            isAuthorized: isPayment,
            ...crud('payment', 'payment'),
        },
        workflow: {
            isAuthorized: isWorkFlow,
            ...crud('workflow', 'workflow'),
        },
        setting: {
            feature: {
                master: { ...crud('setting', 'master') },
                preference: { ...crud('setting', 'preference') },
                integration: { ...crud('setting', 'integration') },
                role_management: { ...crud('setting', 'role_management') },
                user_management: { ...crud('setting', 'user_management') },
            }
        },
        campaigning: {
            isAuthorized: isCampaigning,
            whatsapp_campaign: { ...crud('campaigning', 'whatsapp_campaigning') },
            sms_campaigning: { ...crud('campaigning', 'sms_campaigning') },
            email_campaigning: { ...crud('campaigning', 'email_campaigning') },
        },
    }
}